import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { useQuery } from "@apollo/client";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { GET_TEMPLATE_RECIPES } from "../../app/graphql/queries";
import { selectRecipeCreationOption } from "../../app/homepage/homepage.slice";
import { setLoadingRecipeCreating } from "../../app/recipeCreation/createRecipe.slice";
import { useAppDispatch } from "../../app/store/hooks";
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import useRecipeCreation from "../../hooks/useRecipeCreation";
import { CloseIcon } from "../../iconRef/recipePageIcons";
import { ErrorManagementContext } from "../../utils/errorManagement/ErrorManagementProvider";
import { EventLogsEnum } from '../../utils/events';
import LoaderButton from "../buttons/loaderButton";
import LoadingUpAnimation from "../LoadingUpAnimation";
import styles from "./recipeCreateForm.module.css";

const CreateRecipeFromScratchForm = () => {

    const dispatch = useAppDispatch()
    const history = useHistory();
    const { duplicateTemplateRecipe, loading: savingRecipe } = useRecipeCreation();
    const { cookClubLog } = useContext(ErrorManagementContext);
    const [recipeName, setRecipeName] = useState<string>('')
    const [error, setError] = useState(false);
    const { data: fetchedTemplateRecipeData } = useQuery(GET_TEMPLATE_RECIPES)
    const templateRecipeId = fetchedTemplateRecipeData?.Recipes_E3[0]?.id;
    const { logRecipeEdit } = useLogRecipeEdit();

    const handleClose = () => {
        setError(false);
        dispatch(selectRecipeCreationOption(null));
        dispatch(setLoadingRecipeCreating(false));
        history.push("/")
    }

    const onCompleted = (recipeId: string) => {
        history.push(`/recipe/${recipeId}`);
        dispatch(selectRecipeCreationOption(null));
    }

    const onCreate = () => {
        if (!recipeName) {
            setError(true);
            return;
        }
        logRecipeEdit(EventLogsEnum.APP_RECIPE_CREATE_TEMPLATE, {
            eventData: { recipeName }
        })

        duplicateTemplateRecipe(templateRecipeId, recipeName, (recipeId) => onCompleted(recipeId), (err) => cookClubLog(`Something went wrong.Try Again!`, "", {}, { ui: { type: "info" }, browserConsole: true }));
    };
    if (savingRecipe) {
        return <LoadingUpAnimation />
    }

    return (
        <Grid className={styles.main_grid} spacing={2}>
            <Grid container direction="row">
                <Grid className={styles.heading_style} item xs={6}>
                    <Typography variant='body3'>Create Recipe</Typography>
                </Grid>
                <Grid className={styles.close_btn} item xs={6}>
                    <IconButton onClick={handleClose}><CloseIcon /></IconButton>
                </Grid>
            </Grid>
            <Typography variant='caption3Light'>Build your own recipe from scratch</Typography>
            <TextField
                autoFocus
                className={styles.duplicate_form_input_box}
                color="secondary"
                error={error}
                fullWidth
                onChange={e => { setRecipeName(e.target.value); setError(false) }}
                placeholder="Name your recipe"
                size="small"
                value={recipeName}
                variant="outlined"
            />
            <LoaderButton disabled={savingRecipe} loading={savingRecipe} onClick={onCreate}
                text="Create" />
        </Grid>
    )
}

export default CreateRecipeFromScratchForm;